
import React, { useState, useEffect } from 'react'
import './DateTime.css';
export const DateTime = () => {

    var [date, setDate] = useState(new Date());

    useEffect(() => {
        var timer = setInterval(() => setDate(new Date()), 1000)
        return function cleanup() {
            clearInterval(timer)
        }

    });

    return (
        <div className='inlineDateTime'>
            <p className='m-0'> {date.toLocaleDateString("en-IN")}</p>
            <p className=' mrgnTime'> {date.toLocaleTimeString("en-IN")}</p>


        </div>
    )
}

export default DateTime;